import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import { Button } from "antd";
import { TfiReload } from "react-icons/tfi";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaFileDownload } from "react-icons/fa";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#358c97",
    color: theme.palette.common.white,
    fontSize: "0.7rem",
    padding: "2vh 0.5vh",
    fontWeight: "600",
    lineHeight: "normal",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "0.75rem",
    padding: "1.5vh",
    fontWeight: "700",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
  },
}));

const User = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filter_data, setfilter_data] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    let listimg_restaurants = [];
    if (search !== "") {
      listimg_restaurants = listimg_restaurants.filter((user) => {
        return user.mobile.toLowerCase().match(search.toLowerCase());
      });
    }
    setfilter_data([...listimg_restaurants]);
  }, [search]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      <div className="page_header">
        <h4>User</h4>
      </div>

      <div className="cat_list_header">
        <div className="cat_search_box">
          <TextField
            id="custom-input"
            placeholder="search"
            variant="outlined"
            autocomplete="off"
            size="small"
            className="input_container"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              style: {
                // backgroundColor: "#ffe6e6",
                // border: "1px solid red",
              },
            }}
            FormHelperTextProps={{
              style: {
                marginTop: "0vh",
              },
            }}
          />
        </div>
        <div className="cat_lis_ad_rs">
          <TablePagination
            component="div"
            count={0}
            page={0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 25, 100]}
            labelRowsPerPage="Rows:"
            labelDisplayedRows={() => null}
            SelectProps={{
              inputProps: { "aria-label": "rows" },
              native: true,
            }}
            ActionsComponent={() => null}
          />
          <Button icon={<FaFileDownload />} iconPosition="start">
            Downlode CSV
          </Button>
        </div>
      </div>

      <div className="margin_top_list">
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer component={Paper} className="customScrollbar">
            <Table
              sx={{
                minWidth: 1000,
                boxShadow:
                  "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
              }}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    ID
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    IMAGE
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    NAME
                  </StyledTableCell>

                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    EMAIL
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    PHONE
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    JOINED DATE
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    STATUS
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* {filter_data
                  .slice(page * rowsPerPage, (page + 1) * rowsPerPage)
                  .map((row, index) => ( */}
                <StyledTableRow
                //   key={index}
                //   sx={{
                //     backgroundColor: index % 2 === 0 ? "#cccccc" : "white",
                //   }}
                >
                  <StyledTableCell
                    component="th"
                    scope="row"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                      textTransform: "uppercase",
                    }}
                    width={50}
                    align="center"
                  >
                    134556
                  </StyledTableCell>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                    width={70}
                    align="center"
                  >
                    <div className="user_image_ls_box">
                      <img src="/assets/logo/logo.jpg" alt="logo" />
                    </div>
                  </StyledTableCell>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                    width={130}
                    align="center"
                  >
                    <Link
                      //   to="/admin/restaurant-info"
                      style={{
                        color: "#358c97",
                      }}
                    >
                      Nalla manoj
                    </Link>
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                    width={120}
                  >
                    manoj@gmail.com
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                    width={100}
                  >
                    8328059954
                  </StyledTableCell>
                  <StyledTableCell
                    width={80}
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    May 11,2024
                  </StyledTableCell>
                  <StyledTableCell
                    width={50}
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    <Android12Switch />
                  </StyledTableCell>
                </StyledTableRow>
                {/* ))} */}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={filter_data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </>
  );
};

export default User;
